@use "foundation/_responsive.scss";

.applet-card-body {
  span.with-image {
    max-height: 6.7em;
  }

  * {
    color: white;
  }

  // Fittty's box mode measures the title at its starting size and never grows past it, so start
  // at the card H2 (Figma 6:11900); the sized variants keep their own sizes.
  &:not([class*="sized-applet-card"]) :global(.content .title) {
    font-size: 34px;

    // Figma cuts the title at 4 lines with an ellipsis.
    span {
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
    }
  }
}
